<template>
  <div class="index-sportello" :style="{ height: (contenitoreHeight) + 'px' }">
    <!--<header-app :counterNuovi="counterNuovi"></header-app>-->
    <div>
      <div class="titolo-app col-lg-14 col-md-11 col-sm-6 col-1 no-padding">
        <span class="titolo-bold hidden-xs">
          {{ $t('trasferte.title').toUpperCase() }}
        </span>
      </div>

      <div class="contenitore col-24 no-padding" :style="{ height: (contenitoreHeight - 40) + 'px' }">
        <!-- <menu-app></menu-app> -->
        <sportello3 v-if="$store.state.country === '3'"></sportello3>
        <sportello1 v-if="$store.state.country === '1'"></sportello1>
      </div>

    </div>
  </div>
</template>

<script>
import Sportello3 from './SportelloES.vue'
import Sportello1 from './SportelloIT.vue'

export default {
  props: {
    contenitoreHeight: {
      type: Number
    }
  },
  name: 'IndexSportello',
  components: {
    Sportello3,
    Sportello1
  },
  /*watch: {
    '$mq.resize': 'setContenitoreHeight'
  },*/
  i18n: {
    messages: {
      it_IT: {
        trasferte: {
          title: 'Sportello Digitale'
        }
      },
      fr_FR: {
        trasferte: {
          title: 'Sportello Digitale'
        }
      },
      es_ES: {
        trasferte: {
          title: 'Ventanilla digital'
        }
      },
      de_DE: {
      },
      en_GB: {
      }
    }
  },
  data() {
    return {
      country: ''

    }
  },
  mounted: function () {
    // this.$router.push({name: 'HomePage'})
    //this.setContenitoreHeight()
    this.country = this.$store.state.country
  },
  computed: {
    showIcone: function () {
      let path = this.$route.path
      return (path.indexOf('/trasferte/riepilogo') === 0)
    }
  },
  methods: {
    /*setContenitoreHeight: function () {
      console.log('size')
      this.contenitoreHeight = window.innerHeight - 140
      this.tableHeight = this.contenitoreHeight - 155
    },*/
    goToNuova: function () {
      this.$router.push({ name: 'NuovaTrasferta' })
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.index-sportello {
  .box-centrale {
    width: 100%;
    float: left;
    //padding-left: 15px;
    //padding-right: 15px;
  }

  .set-font();
  height: 100%;

  .menu {
    float: left;
  }

  .language-modal {
    .elemento {
      font-size: 14px;
      margin-top: 5px;
      margin-bottom: 20px;

      .label {
        color: @greenRiva;
      }

      .radio {
        margin-top: 5px;
        color: @greenRiva;
      }

      .value {
        color: #bbbbbb;
      }

      .textarea:focus {
        border: 1px solid @greenRiva;
      }
    }
  }

  .titolo-app {
    padding-left: 5px;
    .set-font(@size: 15px; @color: @greenRiva);
    letter-spacing: 2px;
    overflow: hidden;
    height: 50px;
    line-height: 50px;

    .titolo-bold {
      font-weight: 700;
    }
  }

  .icone {
    padding-top: 10px;

    .icona:hover {
      cursor: pointer;
    }

    .icona {
      text-align: right;
      width: 150px;
      float: right;
    }

    .icona-menu {
      padding-top: 2px;
      padding-left: 0px;
      padding-right: 3px;
      text-align: right;
      display: inline-block;
      vertical-align: middle;
    }

    .label-menu {
      .set-font(@size: 13px; @weight: bold);
      text-align: center;
      display: inline-block;
      line-height: 17px;
      vertical-align: middle;
    }

    .clausole-label {
      line-height: 28px;
    }
  }

  .contenitore {
    -webkit-box-shadow: 0 0 10px 2px #cecece;
    -moz-box-shadow: 0 0 10px 2px #cecece;
    box-shadow: 0 0 10px 2px #cecece;
    background-color: #ffffff;
    margin: auto;
    border-radius: 5px;
    //overflow-x: hidden;
    overflow: auto;
    text-align: center;

    .cat {
      cursor: pointer;

      img {
        cursor: pointer;
        margin-top: 10px;
        height: 65px;
        margin-bottom: 10px;
      }

      .didascaliaIcone {
        // width: 60%;
        word-wrap: break-word;
        margin-right: auto;
        margin-left: auto;
        color: #58585a;
        min-height: 50px;
        font-family: 'Roboto-Bold' !important;
        border-top: 1px solid orange;
        letter-spacing: 1px;
        text-transform: uppercase;
        cursor: pointer;
        padding-top: 10px;
      }

      .docToRead {
        position: relative;
        top: -5px;
        right: 0px;
        padding: 2px 6px;
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SportelloDigitale/IndexSportello.vue